import { format, parseISO, isPast, isFuture } from 'date-fns'
import { nl } from 'date-fns/locale'

export const formatDate = (dateString) => {
  if (!dateString) return ''
  try {
    return format(parseISO(dateString), 'EEEE d MMMM yyyy', { locale: nl })
  } catch (error) {
    return dateString
  }
}

export const formatTime = (timeString) => {
  if (!timeString) return ''
  return timeString.substring(0, 5) // HH:MM
}

export const formatDateTime = (dateString, timeString) => {
  const formattedDate = formatDate(dateString)
  const formattedTime = formatTime(timeString)
  return `${formattedDate} om ${formattedTime}`
}

export const isMeetupPast = (date, startTime) => {
  try {
    const meetupDateTime = new Date(`${date}T${startTime}`)
    return isPast(meetupDateTime)
  } catch (error) {
    return false
  }
}

export const isMeetupUpcoming = (date, startTime) => {
  try {
    const meetupDateTime = new Date(`${date}T${startTime}`)
    return isFuture(meetupDateTime)
  } catch (error) {
    return true
  }
}

export const getMeetupStatus = (date, startTime) => {
  if (isMeetupPast(date, startTime)) {
    return { status: 'past', label: 'Afgelopen', color: 'gray' }
  }

  const now = new Date()
  const meetupDateTime = new Date(`${date}T${startTime}`)
  const hoursUntil = (meetupDateTime - now) / (1000 * 60 * 60)

  if (hoursUntil <= 24) {
    return { status: 'soon', label: 'Binnenkort', color: 'orange' }
  }

  return { status: 'upcoming', label: 'Aankomend', color: 'green' }
}

export const getRegistrationStatusLabel = (status) => {
  const labels = {
    confirmed: 'Bevestigd',
    waitlist: 'Wachtlijst',
    cancelled: 'Geannuleerd'
  }
  return labels[status] || status
}

export const getRegistrationStatusColor = (status) => {
  const colors = {
    confirmed: 'green',
    waitlist: 'yellow',
    cancelled: 'red'
  }
  return colors[status] || 'gray'
}

export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text
  return text.substring(0, maxLength).trim() + '...'
}

export const isEmailValid = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const isValidDate = (dateString) => {
  try {
    const date = new Date(dateString)
    return date instanceof Date && !isNaN(date)
  } catch (error) {
    return false
  }
}

export const isValidTime = (timeString) => {
  const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
  return timeRegex.test(timeString)
}

export const generateSlug = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (error) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
      document.body.removeChild(textArea)
      return true
    } catch (fallbackError) {
      document.body.removeChild(textArea)
      return false
    }
  }
}

export const downloadCSV = (data, filename) => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}